import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { MatIcon } from '@angular/material/icon';
import { PopupTooltipComponent } from '../../../modules/insight-popup-tooltip/components/insight-popup-tooltip/popup-tooltip.component';

@Component({
  selector: 'insight-order-line-languages',
  templateUrl: './order-line-languages.component.html',
  styleUrls: ['./order-line-languages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, CdkOverlayOrigin, PopupTooltipComponent],
  // lets a view space this out only when there is something to show, since the element
  // itself is still in the page when the line has no languages
  host: { '[class.has-languages]': 'hasLanguages()' }
})
export class OrderLineLanguagesComponent {
  public audioLanguages: InputSignal<string[]> = input<string[]>([]);
  public subtitleLanguages: InputSignal<string[]> = input<string[]>([]);

  protected readonly hasLanguages: Signal<boolean> = computed(
    () => this.audioLanguages().length + this.subtitleLanguages().length > 0
  );
}
